import _extends from "@babel/runtime-corejs3/helpers/extends";
import _objectWithoutProperties from "@babel/runtime-corejs3/helpers/objectWithoutProperties";
import React, { memo } from 'react';
import { RecordTag } from '@rexlabs/tag';
import { useDownshiftContext } from '../../../../core';

function DefaultValue(_ref) {
  var index = _ref.index,
      tagRef = _ref.tagRef,
      Value = _ref.Value,
      props = _objectWithoutProperties(_ref, ["index", "tagRef", "Value"]);

  var _useDownshiftContext = useDownshiftContext(),
      clearSelection = _useDownshiftContext.clearSelection,
      clearSelectionAtIndex = _useDownshiftContext.clearSelectionAtIndex;

  var id = props.id,
      name = props.name,
      value = props.value,
      meta = props.meta,
      item = props.item,
      disabled = props.disabled,
      debounce = props.debounce,
      multi = props.multi,
      rest = _objectWithoutProperties(props, ["id", "name", "value", "meta", "item", "disabled", "debounce", "multi"]);

  var Icon = item === null || item === void 0 ? void 0 : item.Icon;
  var label = item === null || item === void 0 ? void 0 : item.label;
  var handleClear = React.useCallback(function (event) {
    event.preventDefault();
    event.stopPropagation();

    if (clearSelectionAtIndex) {
      clearSelectionAtIndex(index);
    } else {
      clearSelection();
    }
  }, [index] // eslint-disable-line
  );
  return Value ? /*#__PURE__*/React.createElement(Value, _extends({}, props, {
    handleClear: handleClear
  })) : /*#__PURE__*/React.createElement(RecordTag, _extends({}, rest, {
    ref: tagRef,
    isDisabled: disabled,
    handleClear: handleClear,
    Icon: Icon
  }), label);
}

export default /*#__PURE__*/memo(DefaultValue);